import React, { useState } from 'react';
import { BadgeCheck, Building2, ChevronRight, IdCard, LogOut, ShieldCheck, Smartphone, User } from 'lucide-react';
import { MobileHeader } from './MobileHeader';
import { StatusBadge } from '../StatusBadge';
import { A4Frame } from '../notice/A4Frame';
import { ScannedNotice } from '../notice/ScannedNotice';
import { officerActivities, officerProfile } from '../../data/officer';
import { sampleCase } from '../../data/sampleCase';
import type { OfficerScreen } from '../../types/officer';
const history = [{
  label: 'মোবাইল অ্যাপে নোটিশ ক্যাপচার ও আপলোড',
  by: 'এএসআই মোঃ রাকিবুল হাসান',
  at: '১৪/০৬/২০২৫ ১০:০৪'
}, {
  label: 'AI/OCR তথ্য সংগ্রহ (গড় নির্ভুলতা ৯৩%)',
  by: 'সিস্টেম',
  at: '১৪/০৬/২০২৫ ১০:০৫'
}, {
  label: '২টি ক্ষেত্র সংশোধন ও যাচাইয়ের জন্য প্রেরণ',
  by: 'এএসআই মোঃ রাকিবুল হাসান',
  at: '১৪/০৬/২০২৫ ১০:১১'
}];
export function NoticeDetails({
  go
}: {
  go: (s: OfficerScreen) => void;
}) {
  const [tab, setTab] = useState<'doc' | 'history'>('doc');
  return <>
      <MobileHeader title="নোটিশের বিস্তারিত" onBack={() => go('activities')} data-id="element-538" data-mp="1u3l1fm2fbnlv" />
      <div className="flex-1 overflow-y-auto bg-[#F4F7FB]" data-id="element-539" data-mp="1q313whdxuhz7">
        <div className="bg-white p-4" data-id="element-540" data-mp="1q4kk67zlgt0z">
          <div className="font-mono text-[13px] font-semibold text-[#003B71]" data-id="element-541" data-mp="24298xqws8kbb">{sampleCase.caseNo}</div>
          <div className="mt-0.5 text-[13px] text-slate-600" data-id="element-542" data-mp="1z3pm7oad74hw">{sampleCase.vehicle} • {sampleCase.offence}</div>
          <div className="mt-2" data-id="element-543" data-mp="2d2fgkw5suq2k"><StatusBadge label="যাচাই অপেক্ষমাণ" data-id="element-544" data-mp="2d1w969drzk2s" /></div>
        </div>
        <div className="grid grid-cols-2 border-b border-border bg-white text-sm" role="tablist" data-id="element-545" data-mp="2925c5nxno7pt">
          {([['doc', 'মূল ডকুমেন্ট'], ['history', 'প্রক্রিয়াকরণ ইতিহাস']] as const).map(([id, l]) => <button key={id} role="tab" aria-selected={tab === id} onClick={() => setTab(id)} className={`border-b-2 py-2.5 font-medium ${tab === id ? 'border-[#003B71] text-[#003B71]' : 'border-transparent text-slate-500'}`} data-id="element-546" data-mp="2htffg6yhbi7p">{l}</button>)}
        </div>
        {tab === 'doc' ? <div className="p-4" data-id="element-547" data-mp="2yvtkk9i9j5fu">
            <div className="overflow-hidden rounded-xl bg-slate-200 p-2" data-id="element-548" data-mp="2ywmh6hnicek9"><A4Frame data-id="element-549" data-mp="33u4t8gwtn9wh"><ScannedNotice data-id="element-550" data-mp="33tv4ewnij8sd" /></A4Frame></div>
          </div> : <ol className="m-4 space-y-4 rounded-2xl bg-white p-4" data-id="element-551" data-mp="33s1xrhcwgokd">
            {history.map(h => <li key={h.label} className="border-l-2 border-[#1769AA]/40 pl-3" data-id="element-552" data-mp="3dk7ji9ck69r4">
                <div className="text-[14px] font-medium" data-id="element-553" data-mp="3dmallrqzjtc7">{h.label}</div>
                <div className="text-[12px] text-slate-500" data-id="element-554" data-mp="3iiix8v5z54em">{h.by} • {h.at}</div>
              </li>)}
          </ol>}
      </div>
    </>;
}
const filters = ['সকল', 'যাচাই অপেক্ষমাণ', 'অনুমোদন অপেক্ষমাণ', 'অনুমোদিত', 'সংশোধনে ফেরত'];
const days = ['সকল দিন', 'আজ', 'গতকাল', 'এই সপ্তাহ'];
export function MyActivities({
  go
}: {
  go: (s: OfficerScreen) => void;
}) {
  const [status, setStatus] = useState('সকল');
  const [day, setDay] = useState('সকল দিন');
  const list = officerActivities.filter(a => (status === 'সকল' || a.status === status) && (day === 'সকল দিন' || a.day === day));
  return <>
      <MobileHeader title="আমার কার্যক্রম" data-id="element-555" data-mp="1unmfmvu6n4sk" />
      <div className="shrink-0 space-y-2 border-b border-border bg-white px-4 py-3" data-id="element-556" data-mp="1pujhsbidh96k">
        <select value={day} onChange={e => setDay(e.target.value)} className="h-9 w-full rounded-lg border border-input bg-white px-3 text-sm" aria-label="তারিখ ফিল্টার" data-id="element-557" data-mp="1kv6x9xez4e75">
          {days.map(d => <option key={d} data-id="element-558" data-mp="2dk43v39tomk2">{d}</option>)}
        </select>
        <div className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1" data-id="element-559" data-mp="2djvs5epfrnag">
          {filters.map(f => <button key={f} onClick={() => setStatus(f)} className={`shrink-0 rounded-full border px-3 py-1 text-[12px] ${status === f ? 'border-[#003B71] bg-[#003B71] text-white' : 'border-border text-slate-600'}`} data-id="element-560" data-mp="28m2j8dwr0f6h">{f}</button>)}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto bg-[#F4F7FB] p-4" data-id="element-561" data-mp="s7b0kspemmad">
        {list.length === 0 ? <p className="py-10 text-center text-sm text-slate-500" data-id="element-562" data-mp="n7omyi5nz411">এই ফিল্টারে কোনো নোটিশ পাওয়া যায়নি।</p> : <ul className="space-y-2.5" data-id="element-563" data-mp="2c0kmtnk9axe0">
            {list.map(a => <li key={a.caseNo} data-id="element-564" data-mp="2gt3ygezdvig6">
                <button onClick={() => go('details')} className="flex w-full items-center gap-2 rounded-xl bg-white p-3 text-left shadow-sm" data-id="element-565" data-mp="2gu6pqo0mbmwm">
                  <div className="min-w-0 flex-1" data-id="element-566" data-mp="272suisfp999a">
                    <div className="truncate font-mono text-[12px] font-semibold text-[#003B71]" data-id="element-567" data-mp="273kdn3s41eio">{a.caseNo}</div>
                    <div className="text-[12.5px] text-slate-600" data-id="element-568" data-mp="2uqk7zzcz7sc5">{a.vehicle}</div>
                    <div className="mt-1 text-[11px] text-slate-400" data-id="element-569" data-mp="2zr7xuhpgy34s">{a.at}</div>
                  </div>
                  <StatusBadge label={a.status} data-id="element-570" data-mp="2ku7fh4t63kiz" />
                  <ChevronRight className="h-4 w-4 text-slate-300" data-id="element-571" data-mp="2pt0u50k6xhkq" />
                </button>
              </li>)}
          </ul>}
      </div>
    </>;
}
export function OfficerProfile({
  onLogout
}: {
  onLogout: () => void;
}) {
  const rows: [typeof User, string, string][] = [[User, 'নাম', officerProfile.name], [IdCard, 'BP/কর্মচারী ID', officerProfile.bp], [BadgeCheck, 'পদবি', officerProfile.designation], [Building2, 'ইউনিট', officerProfile.unit], [Smartphone, 'নিবন্ধিত ডিভাইস', officerProfile.device]];
  return <>
      <MobileHeader title="প্রোফাইল" data-id="element-572" data-mp="5f3ycm5zl8x4" />
      <div className="flex-1 overflow-y-auto bg-[#F4F7FB] p-4" data-id="element-573" data-mp="1flgy0ddjfz1">
        <div className="flex flex-col items-center rounded-2xl bg-white p-5" data-id="element-574" data-mp="39vobd4fh785f">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#006A4E] text-2xl font-bold text-white" data-id="element-575" data-mp="39tk9st51ul8b">রা</div>
          <div className="mt-3 font-semibold" data-id="element-576" data-mp="3inqb10hq0ken">{officerProfile.name}</div>
          <div className="text-[13px] text-slate-500" data-id="element-577" data-mp="3iq2x9puihgxi">নোটিশ প্রসেসিং অপারেটর</div>
        </div>
        <dl className="mt-4 divide-y divide-border rounded-2xl bg-white" data-id="element-578" data-mp="3dv5jy6q78let">
          {rows.map(([Icon, k, v]) => <div key={k} className="flex items-center gap-3 px-4 py-3" data-id="element-579" data-mp="2m62einmkt50l">
              <Icon className="h-4 w-4 shrink-0 text-[#1769AA]" data-id="element-580" data-mp="2m5u1mvqgdzpe" />
              <dt className="w-28 shrink-0 text-[12.5px] text-slate-500" data-id="element-581" data-mp="p4eqvodf9akk">{k}</dt>
              <dd className="text-[13.5px] font-medium" data-id="element-582" data-mp="u4107mq4q6o3">{v}</dd>
            </div>)}
        </dl>
        <div className="mt-4 flex items-center gap-2 rounded-xl bg-[#E8F1FA] p-3 text-[12px] text-[#0f4c80]" data-id="element-583" data-mp="yuzk0wabtmw3"><ShieldCheck className="h-4 w-4" data-id="element-584" data-mp="13ulxn6u2h55f" /> ডিভাইস বাইন্ডিং ও এনক্রিপ্টেড স্থানীয় সংরক্ষণ সক্রিয়</div>
        <button onClick={onLogout} className="mt-4 flex h-12 w-full items-center justify-center gap-2 rounded-xl border border-[#D93036]/40 bg-white font-semibold text-[#D93036]" data-id="element-585" data-mp="67df9kpd4c7n"><LogOut className="h-5 w-5" data-id="element-586" data-mp="g4rpv3olu6s1" /> লগআউট</button>
      </div>
    </>;
}